<template>
  <div class="container p-x-1:mo m-y-5">
    <app-login-form :redirect-to="this.$route.query.redirect" class="m-x-auto"/>
  </div>
</template>

<script>
import AppLoginForm from '@/components/AppLoginForm';

export default {
  name: 'login',
  metaInfo: {
    title: 'Login',
  },
  components: {
    AppLoginForm,
  },
  async beforeRouteLeave (to, from, next) {
    if (to.name === 'tos-password') {
      await window.history.go(-1);
    }
    next();
  },
};
</script>
